/**
 * L2-S13: moved to @miq/platform (services/timetracking.service.ts). This shim keeps the old
 * import path working; new code should import from '@miq/platform'. The move is what makes the
 * idle timers a real singleton: @miq/platform is a federation sharedMappings singleton, so the
 * host and the reports remote now share ONE instance instead of running one timer set each.
 */
export { TimetrackingService, isConnectionActive, isConnectionOffline } from '@miq/platform';
